// Manzana.js – versión estilizada
import React from 'react';
import Lote from './Lote';
import {
  Box, Typography, Button, Card, CardContent, Divider, Stack
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const Manzana = ({
  idManzana,
  lotes,
  currencySymbol,
  onSeleccionarLote,
  obtenerUrlImagenManzana,
}) => {
  const columns = 4;
  const urlImagenManzana = obtenerUrlImagenManzana(idManzana);

  return (
    <Card
      elevation={3}
      sx={{
        width: { xs: '100%', sm: 420 },
        borderRadius: 3,
        overflow: 'hidden',
        backdropFilter: 'blur(6px)',
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 1 }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
            Manzana {idManzana}
          </Typography>

          <Button
            variant="contained"
            component="a"
            href={urlImagenManzana}
            download={`Manzana_${idManzana}.jpg`}
            startIcon={<DownloadIcon />}
            sx={{
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              background: 'linear-gradient(90deg,#00796B,#26A69A)',
              '&:hover': { background: 'linear-gradient(90deg,#004D40,#00796B)' },
            }}
          >
            Plano técnico
          </Button>
        </Stack>

        <Divider sx={{ mb: 2 }} />

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: 1.2,
          }}
        >
          {lotes.map((lote, idx) => (
            <Lote
              key={idx}
              lote={lote}
              currencySymbol={currencySymbol}
              onSeleccionarLote={onSeleccionarLote}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Manzana;
